import {addClass, listener} from "../../../../../modules/vegas/js/util";
import VGCatalogCart from "./cart";

const cart = new VGCatalogCart();

listener('click', '[data-product-item] [data-cart][data-action=add]', function (el, event) {
	let product = el.closest('[data-product-item]');
	if (product) {
		addClass(product, 'in-cart');
		cart.add(product);
	}
}, true);

// Добавляем со страницы товара
listener('click', '[data-product] [data-cart][data-action=add]', function (el, e) {
	let product = el.closest('[data-product]');
	if (product) {
		addClass(product, 'in-cart');
		cart.add(product);
	}
}, true);
